const CONTACT_ANCHOR_PREFIX = 'contact-';

export const contactAnchorId = (contactId) => `${CONTACT_ANCHOR_PREFIX}${contactId}`;

/**
 * Contact id addressed by a company-page hash (`#contact-<id>`), or null.
 * @param {string} [hash] - `location.hash`, including the leading `#`
 * @returns {string|null}
 */
export const contactIdFromHash = (hash) =>
	hash?.startsWith(`#${CONTACT_ANCHOR_PREFIX}`) ? hash.slice(CONTACT_ANCHOR_PREFIX.length + 1) : null;

/**
 * Path of a CRM company page; with `contactId` the page scrolls to and highlights that contact.
 * @param {string} companyId
 * @param {{contactId?: string|null}} [options]
 * @returns {string}
 */
export const companyPagePath = (companyId, { contactId } = {}) =>
	`/crm/companies/${companyId}${contactId ? `#${contactAnchorId(contactId)}` : ''}`;
